import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../helpers/axiosInstance";
import "./deviceDetails.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const DeviceDetails = () => {
    const { id } = useParams();
    const [device, setDevice] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchDeviceDetails = async () => {
            try {
                const response = await axiosInstance.get(`/api/device/devices/${id}`);
                const deviceData = response.data;

                setDevice({ ...deviceData });
            } catch (error) {
                console.error("Error fetching device details:", error);
            }
        };

        fetchDeviceDetails();
    }, [id]);

    if (!device) return (
        <div className="device-details-container">
            <div className="device-details-card">
                <div className="loading-spinner">
                    <div className="spinner-border text-primary"></div>
                </div>
            </div>
        </div>
    );
    return (
        <div className="device-details-container">
            <div className="device-details-card">
                <div className="device-header">
                    <div className="device-info">
                        <div className="info-grid">
                            <div className="info-item">
                                <span className="info-label">Device Name</span>
                                <h1 className="device-name">
                                    <i className="bi bi-cpu"></i>
                                    {device.name}
                                </h1>
                            </div>
                            <div className="info-item">
                                <span className="info-label">Device Type</span>
                                <div className="device-type">
                                    <i className="bi bi-layers"></i>
                                    {device.type}
                                </div>
                            </div>
                        </div>
                        <span className={`status-badge status-${device.status.toLowerCase()}`}>
                            {device.status.toUpperCase()}
                        </span>
                    </div>
                </div>

                {/* Scrollable Table for Device Metadata */}
                <div className="metadata-section" style={{ marginTop: "24px" }}>
                    <h2 className="section-title" style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "20px",
                        fontWeight: 600,
                        color: "#333",
                        marginBottom: "16px",
                        gap: "8px"
                    }}>
                        <i className="bi bi-info-circle" style={{ fontSize: "22px", color: "#007bff" }}></i>
                        Device Metadata
                    </h2>

                    <div className="metadata-grid" style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                        gap: "16px",
                        padding: "16px",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "12px",
                        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
                    }}>
                        {device.Device_Metadata.map((metadata, index) => (
                            <div key={index} className="metadata-item" style={{
                                backgroundColor: "#fff",
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                padding: "12px 16px",
                                display: "flex",
                                flexDirection: "column",
                                fontSize: "13px",
                                color: "#444",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
                            }}>
                                <span className="metadata-key" style={{ fontWeight: 600, color: "#333", marginBottom: "4px" }}>
                                    {metadata.key_name}
                                </span>
                                <span className="metadata-value" style={{ wordBreak: "break-word", color: "#555" }}>
                                    {metadata.value_name}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="installation-section">
                    <div className="installation-header">
                        <h2 className="section-title">
                            <i className="bi bi-geo-alt"></i>
                            Installation Locations
                        </h2>
                    </div>
                    <div className="installation-history">
                        {device.Device_Installation_Histories.map((history, index) => {
                            const isCurrent = index === 0;
                            const currentStatus = device.status;
                            const installDate = history?.installed_at ? new Date(history.installed_at).toLocaleDateString() : "Unknown";

                            const isRemoved = isCurrent && currentStatus.toLowerCase() === "removed";

                            // Prefer bay > location > fallback
                            const displayLocation = history.bay
                                ? `${history.bay.number}(${history.bay.shop.shop_name})`
                                : history.location
                                    ? `${history.location.location_name} (${history.location.module.module_name})`
                                    : "Unknown Location";


                            return (
                                <div
                                    key={index}
                                    className={`installation-card ${isCurrent ? "current-location" : ""}`}
                                    onClick={() => {
                                        setSelectedLocation(history); // Set selected location
                                        console.log("Selected Location:", history); // Log the selected location
                                    }}
                                    title={`Click to view status changes for ${displayLocation}`}
                                >
                                    <div className="installation-card-header">
                                        <i className="bi bi-geo-alt-fill location-icon"></i>
                                        <h3>{displayLocation}</h3>
                                    </div>

                                    <div className="installation-info">
                                        <p className="installation-date">
                                            <i className="bi bi-calendar3"></i> Installed on: {installDate || "Unknown"}
                                        </p>
                                        {isCurrent && (
                                            <div className={`arrow-indicator ${isRemoved ? "removed" : ""}`}>
                                                <i className={`bi ${isRemoved ? "bi-x-circle-fill" : "bi-arrow-up-circle-fill"}`}></i>
                                                <span>{isRemoved ? "Last Installation" : "Current Location"}</span>
                                            </div>
                                        )}
                                    </div>

                                    <p className="view-status-msg">Click to view status changes</p>
                                </div>
                            );
                        })}

                    </div>

                </div>

                <div className="actions-section">
                    <button className="back-button" onClick={() => navigate(-1)}>
                        <i className="bi bi-arrow-left"></i>
                        Back to Devices
                    </button>
                </div>

                {selectedLocation && (
                    <div className="popup-overlay" onClick={() => setSelectedLocation(null)}>
                        <div className="popup-content" onClick={e => e.stopPropagation()}>
                            <div className="popup-header">


                                <h4 className="popup-title">
                                    Status Histroy
                                </h4>

                                <button
                                    className="close-button"
                                    onClick={() => setSelectedLocation(null)}
                                >
                                    <i className="bi bi-x-lg"></i>
                                </button>
                            </div>
                            <div className="popup-body">
                                {selectedLocation.Device_Status_Histories.map((change, idx) => (
                                    <div key={idx} className="detail-item">
                                        <span className="detail-label">Status: </span>
                                        <span className={`detail-value status ${change.status}`}>
                                            {change.status.toUpperCase()}
                                        </span>
                                        <div className="timestamp">
                                            <i className="bi bi-calendar-event"></i>
                                            {change.changed_at.toLocaleString()}
                                        </div>
                                        {/* <p>Changed By: User {change.changed_by}</p> */}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DeviceDetails;
